export default __webpack_public_path__ + "static/media/falcon_join_hover_3.d85cf2a1.svg";